import { NavLink } from 'react-router-dom';

import { Navigation } from '@ingrid/luterkort-react';

import { LocalizationKey, useTranslation } from '~src/i18n/use-translation';

import { AppRoute } from '../routes';

interface NavigationMenuLink {
  label: LocalizationKey;
  route: AppRoute;
  bottom?: boolean;
}

const NavigationMenuLinks: NavigationMenuLink[] = [
  {
    label: 'common.dashboard',
    route: AppRoute.DASHBOARD,
  },
  {
    label: 'common.shipments',
    route: AppRoute.SHIPMENTS,
  },
  {
    label: 'common.transportOrders',
    route: AppRoute.TRANSPORT_ORDERS,
  },
  {
    bottom: true,
    label: 'common.settings',
    route: AppRoute.SETTINGS,
  },
];

export function NavigationMenu() {
  const { t } = useTranslation();

  return (
    <Navigation style={{ flex: '1 1 0%' }}>
      {NavigationMenuLinks.map(({ bottom, label, route }) => (
        <NavLink style={{ display: 'block', marginTop: bottom ? 'auto' : undefined }} key={route} to={route}>
          {t(label)}
        </NavLink>
      ))}
    </Navigation>
  );
}
